import i18next from 'i18next'

import { IS_APP_VISIBLE_STORAGE_KEY } from '@/constants/common'

export const createNewOrderBrowserNotification = (orderId: string) => {
  const t = i18next.t

  const isAnyTabActive =
    localStorage.getItem(IS_APP_VISIBLE_STORAGE_KEY) === 'true'

  if (isAnyTabActive) return

  Notification?.requestPermission()?.then(() => {
    const notification = new Notification(t('orders.new-order.notification'), {
      icon: '/images/yassir-192.png',
      // image: '/images/yassir-192.png',
      tag: orderId
    })
    notification.onclick = () => {
      window.open(
        `${window.location.origin}/orders/new?id=${orderId}`,
        '_blank'
      )
    }
  })
}

export const createNotificationSound = (volume?: number) => {
  const audio = new Audio('/audio/new-order-notification-sound.mp3')
  audio.loop = true
  audio.volume = volume || 0.2
  return audio
}
